// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsSidebar-cls1_wZQ","cls2":"ToolsSidebar-cls2_uoj ToolsSidebar-cls1_wZQ"};